var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-page-container"}},[_c('page-header'),(_vm.sumLoaded)?_c('div',[_c('sales-data'),_c('plane-display')],1):_c('loading-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }